import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavWalletInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || text_colorTextSecondary}
      fillRule="evenodd"
      d="M11.562.4c1.806-.722 3.771.608 3.771 2.554V4.25h1.417A2.75 2.75 0 0 1 19.5 7v7.666a2.75 2.75 0 0 1-2.75 2.75H4.083a2.75 2.75 0 0 1-2.75-2.75V5.677c0-.716.436-1.36 1.1-1.625L11.562.401Zm2.271 2.554V4.25H5.978l6.141-2.457a1.25 1.25 0 0 1 1.714 1.16ZM4.083 5.75c-.69 0-1.25.56-1.25 1.25v7.666c0 .69.56 1.25 1.25 1.25H16.75c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H4.083ZM15 13.333a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavWalletInactive
